module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("11UUV"))).then(() => parcelRequire('1iHdE'));